/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@pages/AdminPage/config/api.config';
import { notificationUserConfig } from '@pages/AdminPage/config/notifications.config';
import { ACTIVATE_USER } from '@pages/AdminPage/api/graphql';

const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IActivateUserPluginMethods extends IPluginMethodMap {
  getActivateUserSync(args?: any): any;
}

export class ActivateUserPlugin implements IAgentPlugin {
  readonly methods: IActivateUserPluginMethods;

  constructor() {
    this.methods = {
      getActivateUserSync: this.getActivateUserSync.bind(this),
    };
  }

  async getActivateUserSync(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.activateUser();
    //   return {
    //   notification: notificationUserConfig?.activateUserSuccess
    //  };
  }

  //Graphql Query example
  async activateUser(args?: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const token = getWhoamiSrv()?.getToken();
    //const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client
          .mutation(ACTIVATE_USER, {
            vuid: args,
          })
          .toPromise();
        if (res?.data?.reactivateUser) {
          return {
            ...res?.data?.reactivateUser,
            notification: notificationUserConfig?.activateUserSuccess,
          };
        }
      }
    } catch (err: any) {
      // log.log('result of update profile=', res?.data?.capsules);
      log.error('error in activate User', err?.message);
      throw err;
    }
  }
}
